<div class="settings d-flex flex-column p-3">
  <div
    role="button"
    #inputPopover
    [atxPopover]="inputOptions"
    [stickWithFullWidth]="true"
    autoClose="outside"
    popoverPlacement="bottom-left"
    class="mb-3"
  >
    <span
      i18n="
        Connect|Connect settings microphone
        title@@connectSettingsMicrophoneTitle"
      >Microphone</span
    >
    <div
      class="bg-light p-2 mt-1 d-flex items-center justify-content-between rounded"
    >
      <span>{{ currentInputDevice?.label }}</span>
      <fa-icon [icon]="['fas', 'angle-down']"></fa-icon>
    </div>
  </div>
  @if (canChangeOutput) {
  <div
    role="button"
    #outputPopover
    [atxPopover]="outputOptions"
    [stickWithFullWidth]="true"
    autoClose="outside"
    popoverPlacement="bottom-left"
    class="mb-3"
  >
    <span
      i18n="
        Connect|Connect settings speakers title@@connectSettingsSpeakersTitle"
      >Speakers</span
    >
    <div
      class="bg-light p-2 mt-1 d-flex items-center justify-content-between rounded"
    >
      <span>{{ currentOutputDevice?.label }}</span>
      <fa-icon [icon]="['fas', 'angle-down']"></fa-icon>
    </div>
  </div>
  }
  <div
    role="button"
    #videoPopover
    [atxPopover]="videoOptions"
    [stickWithFullWidth]="true"
    autoClose="outside"
    popoverPlacement="bottom-left"
    class="mb-3"
  >
    <span
      i18n="Connect|Connect settings camera title@@connectSettingsCameraTitle"
      >Camera</span
    >
    <div
      class="bg-light p-2 mt-1 d-flex items-center justify-content-between rounded"
    >
      <span>{{ currentVideoDevice?.label }}</span>
      <fa-icon [icon]="['fas', 'angle-down']"></fa-icon>
    </div>
  </div>
</div>

<ng-template #inputOptions>
  @for (device of inputDevices$ | async; track device) {
  <div
    class="dropdown-item"
    role="button"
    [class.active]="device.deviceId === currentInputDevice.deviceId"
    (click)="selectDevice(device, 'audioinput')"
  >
    {{ device.label }}
  </div>
  }
</ng-template>

<ng-template #outputOptions>
  @for (device of outputdevices$ | async; track device) {
  <div
    class="dropdown-item"
    role="button"
    [class.active]="device.deviceId === currentOutputDevice.deviceId"
    (click)="selectDevice(device, 'audiooutput')"
  >
    {{ device.label }}
  </div>
  }
</ng-template>

<ng-template #videoOptions>
  @for (device of videoDevices$ | async; track device) {
  <div
    class="dropdown-item"
    role="button"
    [class.active]="device.deviceId === currentVideoDevice.deviceId"
    (click)="selectDevice(device, 'videoinput')"
  >
    {{ device.label }}
  </div>
  }
</ng-template>
